const BlockActionCategorizationDefault = {
    object_id: null,
    name: "Categorization",
    x: 0,
    y: 0,
    width: 5,
    height: 3,
    action_type: { name: "categorization" },
    type: { name: 'action' },
    data: {
        branches: [],
        variable: null,
        variable_redirect: null,
    },
    children: [
        { text: "", index: null, object_id: null, parent_block_id: null },
        { text: "Default", index: null, object_id: null, parent_block_id: null },
    ],
}

const BlockActionCategorizationServerDefault = {
    name: "Categorization",
    action_type: "categorization",
    branches: [],
}

export { BlockActionCategorizationDefault, BlockActionCategorizationServerDefault }
